export type SLOKASI = 'Beiji' | 'Meruyung' | 'Cilandak';
export const LOKASI: { [key: string]: SLOKASI } = {
	BEIJI: 'Beiji',
	MERUYUNG: 'Meruyung',
	CILANDAK: 'Cilandak',
};
